import { CustomNode } from './custom-node';

export const nodeTypes = {
  custom: CustomNode,
};
